module.exports = __webpack_public_path__ + "img/cnaphalocrocis-medinalis.da0f10ed.jpg";